module.exports = __webpack_public_path__ + "static/img/9.514abbd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/sp/9.png
// module id = Jx+a
// module chunks = 0